let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6TgwN")).then(() => parcelRequire('8ALRN'));